<h2 *ngIf="title" class="font-normal text-3xl text-center te-text-gradient">{{ title }}</h2>
<img src="./assets/evsb/img/loading-car.gif" alt="">